import axios from 'axios'
import qs from 'qs'
// import store from '../store/store.js'
import api from '../api/api.js'
import Cookie from "js-cookie"
import router from '../router'
import { Loading, Message } from 'element-ui'
axios.defaults.timeout = 120000;                        //响应时间
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';           //配置请求头
//axios.defaults.baseURL = 'http://open.sk-ai.com:81';   //配置接口地址测试
//axios.defaults.baseURL = 'http://dev.skfrm.sk-ai.com';     //测试
//axios.defaults.baseURL = 'http://www.face.com';   //配置接口地址PHP专用
axios.defaults.baseURL = 'https://skfrm.sk-ai.com';   //正式
//axios.defaults.baseURL = 'http://localhost';   //配置接口地址外网

//POST传参序列化(添加请求拦截器)
axios.interceptors.request.use((config) => {
    //在发送请求之前做某件事
    if(config.method  === 'post'){
        config.data = qs.stringify(config.data);
    }
    return config;
},(error) =>{
    // _.toast("错误的传参", 'fail');
    return Promise.reject(error);
});
 
//返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) =>{
    //对响应数据做些事
    // console.log(res.data.code)
    // alert(JSON.stringify(!res.data.code))
    if(!res.data.code){
        // _.toast(res.data.msg);
        return Promise.reject(res);
    }else {
        if (res.data.code=='9001') {
            // Cookie.remove('FRM_All_Device',{ path: '/' })
            // Cookie.remove('FRM_All_Person',{ path: '/' })
            // Cookie.remove('FRM_RecycleId',{ path: '/' })
            // Cookie.remove('FRM_Token',{ path: '/' })
            // Cookie.remove('FRM_UnregisteredId',{ path: '/' })
            // Cookie.remove('FRM_UserId',{ path: '/' })
            // Cookie.remove('FRM_User_Name',{ path: '/' })
            // Cookie.remove('FRM_appid',{ path: '/' })
            // if (store.state.showMessage) {
            // store.state.showMessage=false
            // Message.error({
            //     message: '请求失败，稍后重试！',
            //         onClose:function(){
            //             store.state.showMessage=true
            //         }
            //     })
            // }    
            // router.push({path:"/login"})
        }else {
            return res;   
        }
    }
}, (error) => {
	console.log(error)
    // _.toast("网络异常", 'fail');
  	if (store.state.showMessage) {
  		store.state.showMessage=false
  		Message.error({
	     	message: '请求失败，稍后重试！',
	     	onClose:function(){
	     		store.state.showMessage=true
	     	}
	    })
  	}
    
    
    return Promise.reject("网络异常",'fail');
});
export default axios;
//返回一个Promise(发送post请求)
// export function fetchPost(url, params) {
//     return new Promise((resolve, reject) => {
//         axios.post(url, params)
//             .then(response => {
//                 resolve(response.data);
//             }, err => {
//                 reject(err);
//             })
//             .catch((error) => {
//                reject(error)
//             })
//     })
// }
////返回一个Promise(发送get请求)
// export function fetchGet(url, param) {
//     return new Promise((resolve, reject) => {
//         axios.get(url, {params: param})
//             .then(response => {
//                 resolve(response.data)
//             }, err => {
//                 reject(err)
//             })
//             .catch((error) => {
//                 reject(error)
//             })
//     })
// }


// WEBPACK FOOTER //
// ./src/api/https.js